/* unplugin-vue-components disabled */import { render } from "./mobile-header.vue?vue&type=template&id=e2d41d2a&scoped=true&ts=true"
import script from "./mobile-header.vue?vue&type=script&lang=ts"
export * from "./mobile-header.vue?vue&type=script&lang=ts"

import "./mobile-header.vue?vue&type=style&index=0&id=e2d41d2a&lang=less&scoped=true"
import "./mobile-header.vue?vue&type=style&index=1&id=e2d41d2a&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/prod-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d41d2a"]])

export default __exports__